import { loadTossPayments, type TossPaymentsSDK } from '@tosspayments/tosspayments-sdk';
import { env } from '@/shared/libs/env';

/**
 * 토스페이먼츠 SDK 싱글톤 로더. 클라이언트 키가 앱 env 라 앱이 소유한다 —
 * 결제창 호출 규약 자체는 `@platform/billing` 의 `createTossCheckout`·`createTossBillingAuth` 가 갖는다.
 * - 단건(VITE_TOSS_CLIENT_KEY)과 자동결제(VITE_TOSS_BILLING_CLIENT_KEY)는 Toss 상점이 달라 SDK 도 따로 띄운다
 * - 모듈 top-level await를 쓰지 않음 (번들 블로킹 방지)
 * - 여러 호출이 동시에 와도 하나의 Promise를 공유
 * - 실패 시 캐시를 비워 다음 호출에서 재시도 가능
 */
function createSdkLoader(clientKey: string): () => Promise<TossPaymentsSDK> {
  let sdkPromise: Promise<TossPaymentsSDK> | null = null;
  return () => {
    if (!sdkPromise) {
      sdkPromise = loadTossPayments(clientKey).catch((err) => {
        sdkPromise = null;
        throw err;
      });
    }
    return sdkPromise;
  };
}

/** 단건 결제창(교육·이어서 결제·정산금) SDK. */
export const getTossPayments = createSdkLoader(env.VITE_TOSS_CLIENT_KEY);

/** 자동결제 카드 등록 SDK. */
export const getTossBillingPayments = createSdkLoader(
  env.VITE_TOSS_BILLING_CLIENT_KEY,
);
